import React, { Component } from "react";
import {UndrawCoding} from 'react-undraw-illustrations'

export default class DesignImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <UndrawCoding primaryColor={theme.imageHighlight} accentColor={theme.text}/>
      );
  }
}
